import { render, staticRenderFns } from "./PopupTest.vue?vue&type=template&id=63f4d296&scoped=true&"
import script from "./PopupTest.vue?vue&type=script&lang=js&"
export * from "./PopupTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4d296",
  null
  
)

export default component.exports